import { Link } from '@/components/link/Link'

type PricingInformationLinkProps = {
  label?: string
  className?: string
}

export default function PricingInformationLink(props: PricingInformationLinkProps) {
  const { label, className } = props

  return (
    <Link href="https://www.paxton.ai/pricing" external size="sm" className={className}>
      {label ?? 'Pricing Information'}
    </Link>
  )
}
